import { ReactNode } from 'react'
import { PopoverStyled } from './style'

interface PopoverProps {
  children?: ReactNode
  id?: string
  open?: boolean
  anchorEl?: null
  onClose?: React.ChangeEventHandler<HTMLFormElement>
}

export const Popover: React.FC<PopoverProps> = ({
  children,
  id,
  open,
  anchorEl,
  onClose
}) => {
  return (
    <PopoverStyled
      id={id}
      open={open as boolean}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
    >
      {children}
    </PopoverStyled>
  )
}
